import { FontAwesomeIcon } from '@appcharge/shared-ui';
import { useTemplateStudioState } from 'state/hooks/template-studio.hook';

import { HeaderPanelControl } from './HeaderPanelControl';

export const PersonalizationController: React.FC = () => {
  const { isPersonalizationOpen, setIsPersonalizationOpen, setIsBrandKitOpen } =
    useTemplateStudioState();

  const handleClick = () => {
    setIsBrandKitOpen(false);
    setIsPersonalizationOpen(!isPersonalizationOpen);
  };

  return (
    <HeaderPanelControl
      isOpen={!!isPersonalizationOpen}
      onClick={handleClick}
      tooltip="Test Personalization"
      icon={<FontAwesomeIcon icon="fa-solid fa-code" className="text-sm" />}
      dataTestId="TemplatesStudio-PersonalizationToggle"
    />
  );
};
